import KpiCard from "@/components/base/KpiCard";
import SectionCard from "./SectionCard";
import { HBarList } from "./charts";
import { salesKpis, comparisonRows, topRevenueServices } from "@/mocks/salesReports";

export default function SalesTab() {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {salesKpis.map((k) => (
          <KpiCard key={k.label} {...k} />
        ))}
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <SectionCard title="مقارنة بالفترة السابقة">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[420px] text-sm">
              <thead>
                <tr className="text-xs font-semibold text-ghasla-text-secondary">
                  <th className="h-11 px-3 text-right">البند</th>
                  <th className="h-11 px-3 text-right">هذا الشهر</th>
                  <th className="h-11 px-3 text-right">الشهر الماضي</th>
                  <th className="h-11 px-3 text-right">التغيير</th>
                </tr>
              </thead>
              <tbody>
                {comparisonRows.map((r) => (
                  <tr key={r.label} className="border-t border-[#F4F8F8] hover:bg-[#FAFEFE]">
                    <td className="h-12 px-3 font-medium text-ghasla-text-heading">{r.label}</td>
                    <td className="h-12 px-3 text-ghasla-text-primary">{r.current}</td>
                    <td className="h-12 px-3 text-ghasla-text-secondary">{r.previous}</td>
                    <td
                      className={`h-12 px-3 font-semibold ${
                        r.tone === "green" ? "text-[#27AE60]" : "text-[#E74C3C]"
                      }`}
                    >
                      {r.change}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </SectionCard>

        <SectionCard title="أعلى الخدمات إيراداً">
          <HBarList items={topRevenueServices} color="#0D6E6E" suffix=" ر.س" />
        </SectionCard>
      </div>
    </div>
  );
}